import * as React from 'react';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import generatePicker from 'antd/es/date-picker/generatePicker';

const DatePicker = generatePicker(momentGenerateConfig);

const TimePicker = React.forwardRef((props, ref) => <DatePicker {...props} picker="time" mode={undefined} ref={ref} />);

TimePicker.displayName = 'TimePicker';

export default TimePicker;
